import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '@hobs/components/Icon';
import Styles from './Alert.module.scss';

const Alert = ({ children, type = 'info' }) => {
  const className = classnames(Styles.alert, Styles[type]);
  return (
    <div className={className}>
      <div className={Styles.icon}>
        {type === 'info' && <>i</>}
        {type === 'error' && <Icon icon="CloseSmall" />}
        {type === 'success' && <Icon icon="tick" />}
      </div>
      <div className={Styles.content}>{children}</div>
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.oneOf(['info', 'error', 'success'])
};

export default Alert;
